/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircleNumber5 = createReactComponent("circle-number-5", "IconCircleNumber5", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  [
    "path",
    {
      d: "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4",
      key: "svg-1"
    }
  ]
]);

export { IconCircleNumber5 as default };
//# sourceMappingURL=IconCircleNumber5.js.map
